import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { getUiDetails } from '../API';
import { setHomeSections, setMaintenanceNotice } from '../Redux/generalOperationSlice/generalOperationSlice';

/**
 * Custom hook to initialize app configuration from backend
 * Should be called once in App.js or top-level component
 */
export const useAppConfiguration = () => {
    const dispatch = useDispatch();
    const hasInitialized = useRef(false);

    useEffect(() => {
        // Only initialize once per app load
        if (hasInitialized.current) return;

        const initializeConfiguration = async () => {
            try {
                const response = await getUiDetails();

                if (response?.data?.status === 'success') {
                    const configData = response.data.data;

                    // Set home sections configuration
                    if (configData?.home_sections) {
                        dispatch(setHomeSections(configData.home_sections));
                    }

                    // Set maintenance notice
                    if (configData?.show_maintenance_notice !== undefined) {
                        dispatch(setMaintenanceNotice({
                            show_maintenance_notice: configData.show_maintenance_notice,
                            maintenance_message: configData.maintenance_message
                        }));
                    }

                    // Note: UI theme color could be added here if needed
                    // For now, keeping existing theme handling
                }

                hasInitialized.current = true;
            } catch (error) {
                console.error('Error initializing app configuration:', error);
                // App will continue with default Redux state values
            }
        };

        initializeConfiguration();
    }, [dispatch]);
};
